import { TalkType } from "@root/data/flow"

export const isMini = (type) => {
  return (
    type === TalkType.Mini ||
    type === true ||
    (typeof type === "string" && type.toLowerCase().includes("mini"))
  )
}

export const workshopTypeText = (type) => {
  return isMini(type) ? "Mini Workshop" : "Workshop"
}

export const numberFixed = (num) => {
  if (num > 9) {
    return num.toString()
  }
  return `0${num}`
}

export const parseHost = (host, host_role) => {
  if (!host) {
    return null
  }
  if (typeof host === "string") {
    return [[host, host_role]]
  }
  return host
}
export const parseHostName = (host, host_role) => {
  const hosts = parseHost(host, host_role)
  return hosts ? hosts.map(([host]) => host).join("、") : ""
}

export const rowClassName = "row equalHeightRow"

export const col1d2 = "col-sm1-6"

export const col1d4c2 = "col-sm1-3"
export const col3d4c2 = "col-sm1-9"

export const col1d3c2 = "col-sm1-6 col-md-4"
export const col2d3c2 = "col-sm1-6 col-md-8"

export const col1d3c3 = "col-6 col-sm1-4"
export const col2d3c3 = "col-12 col-sm1-4"
